import { Component, inject, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AuthService } from '../../../auth/auth.service';

@Component({
  standalone: false,
  selector: 'app-league-options',
  templateUrl: './league-options.component.html',
  styleUrls: ['./league-options.component.scss'],
})
export class LeagueOptionsComponent {

  authService = inject(AuthService);
  @Input({ required: true }) isOwner: boolean;
  constructor(
    private popoverController: PopoverController
  ) { }
  
  async dismiss(value) {
    await this.popoverController.dismiss(value)
  }

}
